"use client";

import type { ReactNode } from "react";
import { createPortal } from "react-dom";
import { useMobileBackLayer } from "@/studio/components/MobileBackStackHost";

/** Full-screen layer portaled onto the studio frame. Phone Back closes it. */
export function StudioPortalLayer({
  open,
  title,
  onClose,
  className,
  attach = "frame",
  captureBack = true,
  children,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  className?: string;
  /** `frame` matches the post dialogs. `body` matches menus and payment layers. */
  attach?: "frame" | "body";
  /** Phone Back closes modal layers. Floating trays leave this off. */
  captureBack?: boolean;
  children: ReactNode;
}) {
  useMobileBackLayer(`portal:${title}`, captureBack && open, onClose);
  if (!open || typeof document === "undefined") return null;
  const root =
    attach === "body"
      ? document.body
      : (document.querySelector(".studio-polish") ?? document.body);
  const node = className ? <div className={className}>{children}</div> : children;
  return createPortal(node, root);
}
